import { createSelector } from '@reduxjs/toolkit';
import { IRegionSpecialPromo } from 'shared/types/specialPromos';
import { selectSpecialPromos } from './selectSpecialPromos';
import { selectJsonQuery } from '../jsonQuery';
import { intersection } from 'ramda';
import { PIK_PROMO_REGIONS, PIK_PROMO } from 'shared/constants/specialPromos';

export const selectAvailablePromo = createSelector(selectSpecialPromos, selectJsonQuery, (specialPromos, jsonQuery) => {
  const currentRegion = jsonQuery.region?.value;
  let specialPromo: IRegionSpecialPromo | undefined;
  if (currentRegion) {
    if (intersection(PIK_PROMO_REGIONS, currentRegion).length > 0) {
      specialPromo = PIK_PROMO;
    } else {
      specialPromo = currentRegion
        ? specialPromos.filter(specialPromo =>
            currentRegion.some(cRegion => specialPromo.regions.some(pRegion => pRegion === cRegion)),
          )[0]
        : undefined;
    }
  }

  return specialPromo;
});
